import {Button, message} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import dayjs, {Dayjs} from "dayjs";
import React from "react";

interface DownloadFlightsButtonProps {
    dateRange: [Dayjs, Dayjs] | null;
}

const DownloadFlightsRefundButton: React.FC<DownloadFlightsButtonProps> = ({dateRange}) => {
    const handleDownload = async () => {
        const access = localStorage.getItem("access") || sessionStorage.getItem("access");

        if (!dateRange) {
            message.error("Please select a valid date range.");
            return;
        }

        const [start, end] = dateRange;
        const startDate = start.format("YYYY-MM-DD");
        const endDate = end.format("YYYY-MM-DD");

        const baseUrl =
            window.location.hostname === "localhost"
                ? "http://localhost:8000"
                : "https://daia.cc";

        try {
            const res = await fetch(
                `${baseUrl}/api/cc/flights-refund-export/?start_date=${startDate}&end_date=${endDate}`, {
                    headers: {
                        Authorization: `Bearer ${access}`,
                    },

                }
            );

            if (!res.ok) {
                throw new Error("Failed to download file.");
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `flight_refund_${startDate}_to_${endDate}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            message.error("An error occurred while downloading the file.");
        }
    };

    return (
        <Button
            icon={<DownloadOutlined/>}
            onClick={handleDownload}
            disabled={!dateRange || dateRange.length !== 2}
            className="rounded-md"
        >
            Download Refund Form
        </Button>
    );
};

export default DownloadFlightsRefundButton;